/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkRealEstateCommandDto
 */
export interface LinkRealEstateCommandDto {
    /**
     * 
     * @type {string}
     * @memberof LinkRealEstateCommandDto
     */
    realEstateId?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkRealEstateCommandDto
     */
    riskId?: string;
}

/**
 * Check if a given object implements the LinkRealEstateCommandDto interface.
 */
export function instanceOfLinkRealEstateCommandDto(value: object): value is LinkRealEstateCommandDto {
    return true;
}

export function LinkRealEstateCommandDtoFromJSON(json: any): LinkRealEstateCommandDto {
    return LinkRealEstateCommandDtoFromJSONTyped(json, false);
}

export function LinkRealEstateCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkRealEstateCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'realEstateId': json['realEstateId'] == null ? undefined : json['realEstateId'],
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
    };
}

export function LinkRealEstateCommandDtoToJSON(json: any): LinkRealEstateCommandDto {
    return LinkRealEstateCommandDtoToJSONTyped(json, false);
}

export function LinkRealEstateCommandDtoToJSONTyped(value?: LinkRealEstateCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realEstateId': value['realEstateId'],
        'riskId': value['riskId'],
    };
}

